import { z } from "zod";

import { productSchema } from "@/features/products/models";
import {
  BILLING_FREQUENCY,
  Category,
  Coupon,
  INTAKE_STATUS,
  Price,
  SUBSCRIPTION_STATUS,
  SUBSCRIPTION_VENDOR,
} from "@/shared/domains";

/**
 * @deprecate Legacy subscription schema
 */
export const planSchema = z.object({
  name: z.string(),
  subscriptionPriceId: z.string(),
  price: z.number(),
  features: z.string(),
  isCompound: z.boolean(),
  description: z.string().optional(),
  disclaimer: z.string().optional(),
  thumbnail: z.url(),
  discount: Coupon.optional(),
  durationInMonths: z.enum(BILLING_FREQUENCY).nullable(),
  priceId: z.number(),
});

/**
 * @deprecated The backend will unify the data structure to match the `detailedSubscriptionSchema`.
 * Once that's done, we'll need to update the list of subscriptions that come from the user.
 */
export const subscriptionSchema = z.object({
  id: z.number(),
  status: z.enum(SUBSCRIPTION_STATUS),
  intakeFormCompleted: z.boolean(),
  hasPendingFollowUp: z.boolean(),
  price: Price.pick({
    id: true,
    durationInMonths: true,
    subscriptionPriceId: true,
  }),
  product: productSchema.pick({ id: true, name: true, slug: true }).extend({
    category: Category.pick({ id: true, name: true, slug: true }),
  }),
  vendor: z.enum(SUBSCRIPTION_VENDOR),
  flowStatus: z.enum(INTAKE_STATUS).nullable(),
});

export const cancellationReasonSchema = z.object({
  id: z.number(),
  label: z.string(),
});

const creditSchema = z.object({
  value: z.number(),
});

export const cancellationDiscountSchema = z.object({
  endDate: z.iso.date().nullable(),
  credit: creditSchema.nullable(),
});
